import React, { useState } from "react";
import { useField, useForm } from "react-final-form";
import { Button, Col, FormGroup, Input, Label, Row } from "reactstrap";
import { GiftCardDto } from "../../store/models/RegistrationDto";

export const GIFTCARDS_FIELD = "giftCards";

export const GiftCardNumbersField: React.FC = () => {
  const form = useForm();
  const { input } = useField<GiftCardDto[]>(GIFTCARDS_FIELD);
  const entries: GiftCardDto[] = Array.isArray(input.value) ? input.value : [];
  const [numberDraft, setNumberDraft] = useState("");
  const [pinDraft, setPinDraft] = useState("");

  const canAdd = numberDraft.trim().length > 0 && pinDraft.trim().length > 0;

  const addEntry = () => {
    const giftCardNumber = numberDraft.trim();
    const pinCode = pinDraft.trim();
    if (!giftCardNumber || !pinCode) return;
    if (entries.some((entry) => entry.giftCardNumber === giftCardNumber)) {
      setNumberDraft("");
      setPinDraft("");
      return;
    }
    form.change(GIFTCARDS_FIELD, [...entries, { giftCardNumber, pinCode }]);
    setNumberDraft("");
    setPinDraft("");
  };

  const removeEntry = (idx: number) =>
    form.change(
      GIFTCARDS_FIELD,
      entries.filter((_, i) => i !== idx)
    );

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      event.preventDefault();
      addEntry();
    }
  };

  return (
    <>
      <Row className="align-items-end">
        <Col xs="auto" style={{ width: 360 }}>
          <FormGroup>
            <Label>Geschenkkartennummer</Label>
            <Input
              type="text"
              maxLength={32}
              value={numberDraft}
              onChange={(e) => setNumberDraft(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </FormGroup>
        </Col>
        <Col xs="auto" style={{ width: 160 }}>
          <FormGroup>
            <Label>PIN</Label>
            <Input
              type="password"
              maxLength={16}
              value={pinDraft}
              onChange={(e) => setPinDraft(e.target.value)}
              onKeyDown={handleKeyDown}
            />
          </FormGroup>
        </Col>
        <Col xs="auto">
          <FormGroup>
            <Button type="button" color="secondary" onClick={addEntry} disabled={!canAdd}>
              + Karte hinzufügen
            </Button>
          </FormGroup>
        </Col>
      </Row>
      {entries.length > 0 && (
        <Row className="mb-2">
          <Col>
            <div className="d-flex flex-wrap" style={{ gap: 6 }}>
              {entries.map((entry, idx) => (
                <span
                  key={`${entry.giftCardNumber}-${idx}`}
                  className="border d-inline-flex align-items-center"
                  style={{
                    padding: "6px 12px",
                    fontWeight: 500,
                    fontSize: 14,
                    backgroundColor: "#e9ecef",
                    color: "#212529",
                    borderRadius: 999,
                  }}
                >
                  {entry.giftCardNumber}
                  {entry.pinCode ? " (PIN ••••)" : ""}
                  <button
                    type="button"
                    aria-label="Karte entfernen"
                    title="Karte entfernen"
                    onClick={() => removeEntry(idx)}
                    style={{
                      marginLeft: 8,
                      border: "none",
                      background: "transparent",
                      cursor: "pointer",
                      lineHeight: 1,
                      fontSize: 18,
                      color: "#495057",
                    }}
                  >
                    ×
                  </button>
                </span>
              ))}
            </div>
          </Col>
        </Row>
      )}
    </>
  );
};
